import { render, staticRenderFns } from "./PricingDetail.vue?vue&type=template&id=68336805&scoped=true"
import script from "./PricingDetail.vue?vue&type=script&lang=js"
export * from "./PricingDetail.vue?vue&type=script&lang=js"
import style0 from "./PricingDetail.vue?vue&type=style&index=0&id=68336805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68336805",
  null
  
)

export default component.exports